module.exports = __webpack_public_path__ + "static/media/Omah jangan diam terus.2c4553f6.jpg";